module.exports = __webpack_public_path__ + "img/w3_paste_black.e34ce215.png";